import loadable from '@loadable/component';

import LoadingPage from '../../components/LoadingPage';

const LoadableActivityLogPage = loadable(() => import('./index'), {
  fallback: LoadingPage,
});

export default LoadableActivityLogPage;
